<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

<form #df="ngForm" (ngSubmit)="onSearchFileCheckingHoReport()" novalidate class="formborder">
  <div class="row m-0">
    <div class="col-md-2 p-1">
      <span class="required-lable">From Date</span>
      <div class="datepicker_feild">
        <input required [matDatepicker]="picker1" dateConvert placeholder="DD/MM/YYYY" name="FromDate" id="FromDate"
               #refFromDate="ngModel" class="form-control input-text-css"
               [(ngModel)]="FromDate" [ngClass]="{
                 'is-invalid': df.submitted && refFromDate.invalid,
                 'alert-warning': refFromDate.invalid && (refFromDate.dirty || refFromDate.touched || refFromDate.untouched)
               }" />
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </div>
    </div>

    <div class="col-md-2 p-1">
      <span class="required-lable">To Date</span>
      <div class="datepicker_feild">
        <input required [matDatepicker]="picker2" dateConvert placeholder="DD/MM/YYYY" name="ToDate" id="ToDate"
               #refToDate="ngModel" class="form-control input-text-css"
               [(ngModel)]="ToDate" [ngClass]="{
                 'is-invalid': df.submitted && refToDate.invalid,
                 'alert-warning': refToDate.invalid && (refToDate.dirty || refToDate.touched || refToDate.untouched)
               }" />
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </div>
    </div>

    <div class="col-md-2 p-1">
      <span>Status</span>
      <select name="Status" id="Status" #refStatus="ngModel"
              [(ngModel)]="Status" class="form-control input-text-css">
        <option value="">Select Status</option>
        <option *ngFor="let opt of statusOptions" [value]="opt">{{ opt }}</option>
      </select>
    </div>

    <div class="col-md-1 p-1">
      <button type="submit" class="mt-3 btn font-size-12 button-btn w-100" [disabled]="!df.form.valid">
        Search
      </button>
    </div>

    <div class="col-md-4 p-1" *ngIf="isSearched && DataSource">
      <div class="search-text mt-3">
        <div class="bg-light rounded rounded-pill shadow-sm">
          <div class="input-group">
            <input type="text" id="FilterInputSearch" name="FilterInputSearch" (keyup)="applyFilter($event.target.value)"
                   placeholder="What're you searching for?" class="form-control border-0 bg-light" />
            <div class="input-group-append">
              <button id="button-addon1" type="button" class="btn btn-link text-primary">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="mt-2" *ngIf="isSearched && DataSource">
  <div class="table-responsive">
    <mat-table [dataSource]="DataSource" matSort style="max-width: 100%; overflow: auto; max-height: 65vh;">
      <!-- # Column -->
      <ng-container matColumnDef="Id">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="grid-header mw50">#</mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index" class="grid-cell mw50">{{ i + 1 }}</mat-cell>
      </ng-container>

      <!-- Application No -->
      <ng-container matColumnDef="Application_No">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="grid-header">Application No</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Application_No }}</mat-cell>
      </ng-container>

      <!-- Application Date -->
      <ng-container matColumnDef="Application_Date">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="grid-header">Application Date</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Application_Date }}</mat-cell>
      </ng-container>

      <!-- Loan No -->
      <ng-container matColumnDef="Loan_No">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="grid-header">Loan No</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Loan_No }}</mat-cell>
      </ng-container>

      <!-- Loan Date -->
      <ng-container matColumnDef="Loan_Date">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="grid-header">Loan Date</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Loan_Date }}</mat-cell>
      </ng-container>

      <!-- Customer Name -->
      <ng-container matColumnDef="Customer_Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="grid-header">Customer Name</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Customer_Name }}</mat-cell>
      </ng-container>

      <!-- Application Loan Amount -->
      <ng-container matColumnDef="Application_LoanAmount">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="grid-header text-right">Loan Amount</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell text-right">{{ row.Application_LoanAmount }}</mat-cell>
      </ng-container>

      <!-- Branch Name -->
      <ng-container matColumnDef="Branch_Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="grid-header">Branch Name</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Branch_Name }}</mat-cell>
      </ng-container>

      <!-- Product Name -->
      <ng-container matColumnDef="Product_Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="grid-header">Product Name</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Product_Name }}</mat-cell>
      </ng-container>

      <!-- EMP Source Name -->
      <ng-container matColumnDef="EMP_Source_Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="grid-header">Source Name</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{ row.EMP_Source_Name }}</mat-cell>
      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="Action">
        <mat-header-cell *matHeaderCellDef class="grid-header text-center">Action</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell text-center">
          <i class="fa fa-eye btn_detail" (click)="onAction(row)" title="View Details" style="cursor: pointer; font-size: 1.1rem;"></i>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    <div class="row m-0 pt-2 pb-1" *ngIf="isSearched && DataSource">
      <div class="col-md-4">
        <button class="mt-3 btn font-size-12 button-btn" (click)="exportexcelNew()">
          <i class="fa fa-file-export mr-1" style="font-size: medium; cursor: pointer"></i>
          Export
        </button>
      </div>
      <div class="col-md-8 text-right">
        <mat-paginator pageSize="15" [pageSizeOptions]="[15, 30, 50, 100]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
  </div>
</div>

<table id="export-filechecking-ho" class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none">
  <tr>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">#</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Application No</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Application Date</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Loan No</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Loan Date</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Customer Name</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Loan Amount</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Branch Name</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Product Name</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">Source Name</th>
  </tr>
  <tr *ngFor="let x of (DataSource ? DataSource.filteredData : []); let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ x.Application_No }}</td>
    <td style="mso-number-format:'dd\/mm\/yy';">{{ formatDateForExcel(x.Application_Date) }}</td>
    <td>{{ x.Loan_No }}</td>
    <td style="mso-number-format:'dd\/mm\/yy';">{{ formatDateForExcel(x.Loan_Date) }}</td>
    <td>{{ x.Customer_Name }}</td>
    <td>{{ x.Application_LoanAmount }}</td>
    <td>{{ x.Branch_Name }}</td>
    <td>{{ x.Product_Name }}</td>
    <td>{{ x.EMP_Source_Name }}</td>
  </tr>
</table>

<!-- Detail Modal Popup -->
<div class="modal fade in" id="FileCheckingDetailModal" tabindex="-1" role="dialog" aria-labelledby="detailModalLabel"
     data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div class="modal-content border-0 shadow-lg">
      <div class="modal-header py-2" style="background: var(--theme-primary); color: #fff;">
        <h6 class="modal-title m-0 text-white font-weight-bold d-flex align-items-center" id="detailModalLabel">
          File Checking HO Detail
          <span class="badge ml-2 px-2 py-1" style="background: rgba(255, 255, 255, 0.2); color: #fff; border: 1px solid rgba(255, 255, 255, 0.35); font-size: 0.825rem; font-weight: normal;" *ngIf="selectedLoanNo">
            Loan No: {{ selectedLoanNo }}
          </span>
        </h6>
        <button type="button" (click)="onCloseModal()" class="close text-white" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-3" style="max-height: 70vh; overflow-y: auto;">
        <div class="table-responsive" *ngIf="detailList && detailList.length > 0; else noDetailData">
          <table class="table table-bordered table-hover font-size-12 mb-0">
            <thead class="bg-light">
              <tr>
                <th style="width: 40px;" class="text-center grid-header">#</th>
                <th class="grid-header">File Checking Question</th>
                <th class="grid-header text-center">Selected Option</th>
                <th class="grid-header text-center">Added On</th>
                <th class="grid-header">Added By</th>
                <th class="grid-header">Remark</th>
                <th class="grid-header text-center">Pending Days</th>
                <th class="grid-header text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of detailList; let i = index">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ item.FileCheckingName }}</td>
                <td class="text-center">{{ item.SelectOption }}</td>
                <td class="text-center">{{ item.AddedOn }}</td>
                <td>{{ item.EmployeeName }}</td>
                <td>{{ item.Remark || '-' }}</td>
                <td class="text-center">
                  <span *ngIf="item.Pending_Days && item.Pending_Days > 0" class="text-danger font-weight-bold">
                    {{ item.Pending_Days }}
                  </span>
                  <span *ngIf="!item.Pending_Days || item.Pending_Days <= 0" class="text-success font-weight-bold">
                    On time
                  </span>
                </td>
                <td class="text-center">
                  <span class="badge px-3 py-1"
                        [ngClass]="{
                          'badge-glassy-completed': item.Action_Status === 'Completed',
                          'badge-glassy-pending': item.Action_Status === 'Pending',
                          'badge-glassy-before': item.Action_Status === 'Before Disbursement',
                          'badge-glassy-after': item.Action_Status === 'After Disbursement',
                          'badge-glassy-default': !item.Action_Status
                        }">
                    {{ item.Action_Status || '-' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #noDetailData>
          <div class="text-center py-4 text-muted">
            <i class="fa fa-folder-open fa-2x mb-2"></i>
            <p class="m-0">No File Checking Details Found</p>
          </div>
        </ng-template>
      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn button-btn btn-sm mr-2" (click)="openFileCheckingDialog()">
          Submit Document
        </button>
        <button type="button" class="btn button-btn btn-sm" (click)="onCloseModal()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
